import type { PostContentObjectList } from 'models';
import { Modal, message } from 'ui';
import { PostForm, type PostFormValues } from '../post-form';
import { useUpdatePostMutation } from '../queries';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  postContentObject: PostContentObjectList;
  type: 'announcement' | 'journal' | 'post';
};

const titleByType = {
  announcement: 'Edit announcement',
  journal: 'Edit note',
  post: 'Edit post',
};

const EditPostModal = ({ isOpened, onCancel, postContentObject, type }: P) => {
  const { isPending: isLoading, mutate: updatePost } = useUpdatePostMutation();

  const onSubmit = (values: PostFormValues) => {
    updatePost(
      {
        attachments: values.attachments.files,
        communityId: values.community?.value,
        htmlContent: values.htmlContent,
        id: postContentObject.post.id,
        pinned: values.pinned,
        textContent: values.textContent,
      },
      {
        onSuccess() {
          message.success('Successfully updated');
          onCancel();
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title={titleByType[type]} width="medium">
      <Modal.HugContent>
        <PostForm
          isLoading={isLoading}
          mode="edit"
          onSubmit={onSubmit}
          postContentObject={postContentObject}
          type={type}
        />
      </Modal.HugContent>
    </Modal>
  );
};

export default EditPostModal;
